import React from 'react';
import { Alert, Typography } from 'antd';
import ChangedLifeCycleAlert from './ChangedLifeCycleAlert';
import { lifeCycleEntitiesMap } from '../../constants/lifeCycle';

const Body = ({
  canChange,
  changedLifeCycleData,
  entity,
  roomId,
  control,
  initialValue,
  setIsFetchOptionsError,
  FormComponent,
}) => {
  if (canChange) {
    return (
      <CanChangeBody
        changedLifeCycleData={changedLifeCycleData}
        entity={entity}
        roomId={roomId}
        control={control}
        initialValue={initialValue}
        setIsFetchOptionsError={setIsFetchOptionsError}
        FormComponent={FormComponent}
      />
    );
  }

  const changedStageData = changedLifeCycleData?.find(findChangedStageItem);

  return <CanNotChangeBody changedStageData={changedStageData} />;
};

export default Body;

function CanChangeBody({
  changedLifeCycleData,
  entity,
  roomId,
  control,
  initialValue,
  setIsFetchOptionsError,
  FormComponent,
}) {
  if (changedLifeCycleData != null) {
    return (
      <ChangedLifeCycleAlert entities={changedLifeCycleData} entity={entity} />
    );
  }

  if (roomId) {
    return (
      <FormComponent
        control={control}
        setIsFetchError={setIsFetchOptionsError}
        roomId={roomId}
        initialValue={initialValue}
      />
    );
  }

  return null;
}

const descriptionLabels = {
  [lifeCycleEntitiesMap.stage]: 'стадию',
  [lifeCycleEntitiesMap.step]: 'этап',
  [lifeCycleEntitiesMap.acceptanceStatus]: 'результат приемки',
};

function CanNotChangeBody({ changedStageData, entity }) {
  const description = (
    <Typography>
      {Boolean(changedStageData) && (
        <Typography.Paragraph>
          Стадия помещения была изменена на {changedStageData.actual}.
        </Typography.Paragraph>
      )}

      <Typography.Paragraph>
        В модуле «Жилой фонд» допускается изменять {descriptionLabels[entity]}{' '}
        только, если помещение не находится в стадии{' '}
        <Typography.Text strong>Приемка</Typography.Text>{' '}
      </Typography.Paragraph>
    </Typography>
  );

  return (
    <Alert
      type="info"
      message="Изменять можно в модуле «Приемки»"
      description={description}
    />
  );
}

function findChangedStageItem(item) {
  return item.type === lifeCycleEntitiesMap.stage;
}
